<template>
    <div class="quotation">
        <home-nav></home-nav>
        <img class="quotation-back" src="@/assets/images/quotation/dingzhi_bg.png" alt="">
        <div class="quotation-box">
            <div class="quotation-box-top">
                <img src="@/assets/images/quotation/baojia_img_title.png" alt="">
            </div>
            <div class="quotation-box-title">
                累计已为 865,536,1人次 报价，服务对比，选择包车最优解
            </div>

            <el-form class="quotation-box-form" ref="form" :model="form" label-width="80px">

                <p class="form-title">- 在线预约专属行程报价 -</p>

                <el-form-item label="*出发地点">
                    <el-col :span="22">
                        <el-cascader
                                style="width: 100%;"
                                placeholder="出发城市"
                                :options="options"
                                filterable
                                v-model="form.startCity"
                                @change="startcityChange"
                        >
                        </el-cascader>
                    </el-col>
                    <!--<el-col :span="1">
                        &nbsp;
                    </el-col>
                    <el-col :span="15">
                        <el-input v-model="form.startDetail" placeholder="详细的地址能更精准的报价哦"></el-input>
                    </el-col>-->
                </el-form-item>

                <!--<el-form-item label="目的地点">
                    <el-col :span="7">
                        <el-cascader
                                placeholder="目的城市"
                                :options="options"
                                filterable
                                v-model="form.endCity"
                        >
                        </el-cascader>
                    </el-col>
                    <el-col :span="1">
                        &nbsp;
                    </el-col>
                    <el-col :span="15">
                        <el-input v-model="form.endDetail" placeholder="详细的地址能更精准的报价哦"></el-input>
                    </el-col>
                </el-form-item>

                <el-form-item label="乘车人数">
                    <el-col :span="10">
                        <el-input v-model="form.number" placeholder="乘车人数"></el-input>
                    </el-col>
                    <el-col :span="1">
                        &nbsp;
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="是否往返" style="width: 300px;margin: 0;">
                            <el-radio-group v-model="form.radio">
                                <el-radio label="1">是</el-radio>
                                <el-radio label="2">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-form-item>-->

                <el-form-item label="*手机号码">
                    <el-col :span="22">
                        <el-input v-model="form.telephone" placeholder="请输入您的手机号码，报价结果将发送至您的手机号"></el-input>
                    </el-col>
                </el-form-item>

                <div class="sendText">- 发给以下车队获取报价 -</div>

                <el-form-item class="sendTeamList">
                    <el-checkbox-group class="sendTeamListGroup"
                                       v-model="checkedTeam"
                                       @change="handleCheckedTeamChange"
                    >
                        <el-checkbox v-for="teamName in teamAll" :label="teamName" :key="teamName">
                            {{teamName}}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                <el-form-item class="bottom-btn">
                    <el-col :span="22">
                        <el-button type="danger" @click="onSubmit">免费获取车队报价</el-button>
                    </el-col>
                </el-form-item>

                <div class="protect">
                    * 预约后会有专门的司机联系沟通您的需求
                </div>
            </el-form>
        </div>

        <!--底部-->
        <home-footer></home-footer>
    </div>
</template>

<script>
    import homeNav from '@/components/homeNav';
    import homeFooter from '@/components/homeFooter';

    const cityOptions = ['上海', '北京', '广州', '深圳'];
    export default {
        name: "quotation",
        components: {
            homeNav,
            homeFooter
        },
        data() {
            return {
                form: {
                    startCity: [], //出发城市
                    startDetail: '', //出发城市详细地址
                    endCity: [], //目的城市
                    endDetail: '', //目的城市详细地址
                    number: '',  //乘车人数
                    radio: '', //是否往返
                    telephone: '', //手机号码
                },

                options: [],
                pic_arr: [
                    require('@/assets/images/quotation/n1.png'),
                    require('@/assets/images/quotation/n2.png'),
                    require('@/assets/images/quotation/n3.png'),
                    require('@/assets/images/quotation/n4.png'),
                    require('@/assets/images/quotation/n5.png'),
                    require('@/assets/images/quotation/n6.png'),
                    require('@/assets/images/quotation/n7.png'),
                    require('@/assets/images/quotation/n8.png'),
                    require('@/assets/images/quotation/n9.png'),
                    require('@/assets/images/quotation/n0.png')
                ],
                teamList: '',
                cityId: '',
                team_id_list: "",
                cityinfo_id_list: "",

                checkedTeam: [],
                teamAll: cityOptions,
            }
        },
        mounted: function () {
            this.getCityData();
        },
        methods: {
            onSubmit() {
                var that = this;
                if (that.form.startCity == undefined || that.form.startCity.length <= 0) {
                    // layer.msg('出发城市不能为空~', {icon: 2});
                    this.$message('出发城市不能为空~');
                    return;
                }
                if (that.form.telephone == undefined || that.form.telephone.length <= 0) {
                    // layer.msg('手机号码不能为空~', {icon: 2});
                    this.$message('手机号码不能为空~');
                    return;
                }
                /*that.shaindex = layer.load(1, {
                    shade: [0.1, '#fff'] //0.1透明度的白色背景
                });*/
                //循环组装车队id
                that.teamList.forEach((item) => {
                    that.team_id_list = that.team_id_list + item.team_id + ",";
                    that.cityinfo_id_list = that.cityinfo_id_list + item.city_info_id + ",";
                })
                that.cityinfo_id_list = that.cityinfo_id_list.substr(0, that.cityinfo_id_list.length - 1);
                that.team_id_list = that.team_id_list.substr(0, that.team_id_list.length - 1);
                that.$axios.post('/CustomizedItinerary', {
                    start_city: that.form.startCity[1],
                    source: "PC",
                    mobile: that.form.telephone,
                    team_id: that.team_id_list,
                    city_info_id: that.cityinfo_id_list
                }).then((res) => {
                    res = res.data;
                    console.log(res)
                    if (res.status == 200) {
                        that.form.startCity = [];
                        that.form.startDetail = '';
                        that.form.endCity = [];
                        that.form.endDetail = '';
                        that.form.number = '';
                        that.form.radio = '';
                        that.form.telephone = '';
                        // layer.closeAll();
                    } else {
                        // layer.closeAll();
                        // layer.msg('网络异常，请刷新！', {icon: 2});
                        this.$message('网络异常，请刷新！');
                    }

                }).catch((error) => {
                    console.log(error);
                });
            },
            getCityData() {
                var that = this;
                that.$axios.get('/provinceAndCity', {}).then((res) => {
                    res = res.data;
                    // console.log(res)
                    if (res.status == 200) {
                        that.options = res.data;
                    } else {
                        // layer.msg('系统错误，请刷新！', {icon: 2});
                        this.$message('系统错误');
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },
            startcityChange() {
                var that = this;
                //切换城市之后显示的
                that.$axios.post('/cityNameGetId', {
                    city_name: that.form.startCity[1],
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        that.cityId = res.data;
                        that.getThreeTime(that.cityId); //获取三家车队
                    } else {
                        // layer.msg('系统错误，请刷新！', {icon: 2});
                        this.$message('系统异常，请刷新！');
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },
            getThreeTime(id) {
                var that = this;
                if (id != '') {
                    that.$axios.post('/CustomizedItineraryTeam', {
                        city_id: id
                    }).then((res) => {
                        res = res.data;
                        if (res.status == 200) {
                            that.teamList = res.data;
                        } else {
                            // layer.msg('数据获取失败，请刷新！', {icon: 2});
                            this.$message('数据获取失败，请刷新！');
                        }
                    }).catch((error) => {
                        console.log(error);
                    });
                } else {
                    // layer.msg('请选择城市！');
                    this.$message('请选择城市！');
                }
            },

            handleCheckedTeamChange(value) {
                console.log(value)
                /*let checkedCount = value.length;
                this.checkAll = checkedCount === this.cities.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;*/
            }
        }
    }
</script>

<style scoped>
    @import './quotation.css';
</style>



// WEBPACK FOOTER //
// src/pages/quotation/quotation.vue